import Container from "../Components/Container";
import { GoArrowRight } from "react-icons/go";
import {
  FaFacebook,
  FaInstagram,
  FaLinkedinIn,
  FaGithub,
} from "react-icons/fa";
import { FaLocationDot, FaPhone } from "react-icons/fa6";
import { MdEmail } from "react-icons/md";

export default function Contact() {
  return (
  <section id="contact" className=" snap-start">
      <Container transparent innerPadding="lg:p-6">
        <div className="grid lg:grid-cols-2 gap-4">
          <Container outterPadding="" transparent>
            <div className="flex flex-col justify-center items-center">
              <div className="text-sky-800 font-extrabold">Contact</div>
              <div className="text-2xl font-semibold">Get In Touch</div>
              <div className="h-1 bg-sky-800 w-36 my-2"></div>
            </div>
            <p>You can get in touch with me by using the following contact details:</p>

            <div className="flex gap-3 my-3">
              <div>
                <div className="p-3 bg-sky-800 rounded-full">
                  <FaLocationDot className="text-white" />
                </div>
              </div>
              <div>
                <div className="font-bold">Address</div>
                <div>
                  Telekom Networks Malawi Plc.,
                  <br /> P.O. Box 3039, Blantyre.
                </div>
              </div>
            </div>

            <div className="flex gap-3 items-center my-3">
              <div>
                <div className="p-3 bg-sky-800 rounded-full">
                  <FaPhone className="text-white" />
                </div>
              </div>
              <div>
                <div className="font-bold">Phone Numbers</div>
                <div className="flex flex-col lg:flex-row lg:gap-3">
                  <a href="tel:+265888066526">+265 888 066 526</a> <span className="hidden lg:flex">/</span>
                  <a href="tel:+265997766952">+265 997 766 952</a>
                </div>
              </div>
            </div>

            <div className="flex gap-3 items-center my-3">
              <div>
                <div className="p-3 bg-sky-800 rounded-full">
                  <MdEmail className="text-white" />
                </div>
              </div>
              <div>
                <div className="font-bold">Email</div>
                <div className="flex flex-col">
                  <a href="tel:hlakudzala@gmail.com">hlakudzala@gmail.com</a>
                </div>
              </div>
            </div>

            <div className="flex gap-4 justify-center">
              <a href="www.linkedin.com/in/happy-lakudzala" className="p-3 bg-sky-800 rounded-full">
                <FaLinkedinIn className="text-white text-lg" />
              </a>
              <a href="https://www.facebook.com/" className="p-3 bg-sky-800 rounded-full">
                <FaFacebook className="text-white text-lg" />
              </a>
              <a href="https://www.instagram.com/" className="p-3 bg-sky-800 rounded-full">
                <FaInstagram className="text-white text-lg" />
              </a>
              <a href="https://github.com/iam-hq" className="p-3 bg-sky-800 rounded-full">
                <FaGithub className="text-white text-lg" />
              </a>
            </div>
          </Container>

          <Container outterPadding="" hasShadow>
            <div className="font-semibold text-2xl mb-3">Send a Message</div>
            <form className="space-y-2">
              <div>
                <label for="name" class="block mb-1 font-medium text-gray-900">
                  Name
                </label>
                <input
                  type="text"
                  id="name"
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-sky-500 focus:border-sky-500 block w-full p-2.5"
                  placeholder="Name"
                  requisky
                />
              </div>
              <div>
                <label for="email" class="block mb-1 font-medium text-gray-900">
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-sky-500 focus:border-sky-500 block w-full p-2.5"
                  placeholder="Email"
                  requisky
                />
              </div>
              <div>
                <label
                  for="message"
                  class="block mb-1 font-medium text-gray-900"
                >
                  Message
                </label>
                <textarea
                  type="text"
                  id="message"
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-sky-500 focus:border-sky-500 block w-full p-2.5"
                  placeholder="Message"
                  requisky
                />
              </div>
              <div className="flex justify-end mt-10">
                <button className="inline-flex items-center justify-center px-5 py-3 text-base font-medium text-center text-white rounded-full bg-sky-800 hover:bg-sky-800 focus:ring-4 focus:ring-sky-300">
                  Send Message
                  <GoArrowRight className="w-5 h-5 ml-2 -mr-1" />
                </button>
              </div>
            </form>
          </Container>
        </div>
      </Container>
    </section>
  );
}
